import React from "react";

export const dropdownCaret = <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g clipPath="url(#clip0_1042_22552)">
        <path
            d="M8.00065 15.1663C4.04732 15.1663 0.833984 11.953 0.833984 7.99967C0.833984 4.04634 4.04732 0.833008 8.00065 0.833008C11.954 0.833008 15.1673 4.04634 15.1673 7.99967C15.1673 11.953 11.954 15.1663 8.00065 15.1663ZM8.00065 1.83301C4.60065 1.83301 1.83398 4.59967 1.83398 7.99967C1.83398 11.3997 4.60065 14.1663 8.00065 14.1663C11.4007 14.1663 14.1673 11.3997 14.1673 7.99967C14.1673 4.59967 11.4007 1.83301 8.00065 1.83301Z"
            fill="white"
        />
        <path
            d="M8.00013 10.0069C7.87346 10.0069 7.7468 9.96026 7.6468 9.86026L5.29344 7.50693C5.1001 7.3136 5.1001 6.9936 5.29344 6.80026C5.48677 6.60694 5.80677 6.60694 6.0001 6.80026L8.00013 8.80026L10.0001 6.80026C10.1935 6.60694 10.5135 6.60694 10.7068 6.80026C10.9001 6.9936 10.9001 7.3136 10.7068 7.50693L8.35346 9.86026C8.25346 9.96026 8.1268 10.0069 8.00013 10.0069Z"
            fill="white"
        />
    </g>
    <defs>
        <clipPath id="clip0_1042_22552">
            <rect width="16" height="16" fill="white"/>
        </clipPath>
    </defs>
</svg>
export const circleXIcon = <svg
    width="25"
    height="25"
    viewBox="4 4 20 20"
    fill="#EBEBEB"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M10.6982 18.1766C10.4766 18.1766 10.2549 18.0949 10.0799 17.9199C9.74159 17.5816 9.74159 17.0216 10.0799 16.6832L16.6833 10.0799C17.0216 9.74159 17.5816 9.74159 17.9199 10.0799C18.2583 10.4183 18.2583 10.9783 17.9199 11.3166L11.3166 17.9199C11.1532 18.0949 10.9199 18.1766 10.6982 18.1766Z"
        fill="#434343"
    />
    <path
        d="M17.3016 18.1766C17.0799 18.1766 16.8583 18.0949 16.6833 17.9199L10.0799 11.3166C9.74159 10.9783 9.74159 10.4183 10.0799 10.0799C10.4182 9.74159 10.9782 9.74159 11.3166 10.0799L17.9199 16.6832C18.2583 17.0216 18.2583 17.5816 17.9199 17.9199C17.7449 18.0949 17.5233 18.1766 17.3016 18.1766Z"
        fill="#434343"
    />
</svg>
export const chatMessageIcon = <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M14.166 1.66699H5.83268C3.53268 1.66699 1.66602 3.52533 1.66602 5.81699V10.8003V11.6337C1.66602 13.9253 3.53268 15.7837 5.83268 15.7837H7.08268C7.30768 15.7837 7.60768 15.9337 7.74935 16.117L8.99935 17.7753C9.54935 18.5087 10.4493 18.5087 10.9993 17.7753L12.2493 16.117C12.4077 15.9087 12.6577 15.7837 12.916 15.7837H14.166C16.466 15.7837 18.3327 13.9253 18.3327 11.6337V5.81699C18.3327 3.52533 16.466 1.66699 14.166 1.66699ZM6.66602 10.0003C6.19935 10.0003 5.83268 9.62533 5.83268 9.16699C5.83268 8.70866 6.20768 8.33366 6.66602 8.33366C7.12435 8.33366 7.49935 8.70866 7.49935 9.16699C7.49935 9.62533 7.13268 10.0003 6.66602 10.0003ZM9.99935 10.0003C9.53268 10.0003 9.16602 9.62533 9.16602 9.16699C9.16602 8.70866 9.54102 8.33366 9.99935 8.33366C10.4577 8.33366 10.8327 8.70866 10.8327 9.16699C10.8327 9.62533 10.466 10.0003 9.99935 10.0003ZM13.3327 10.0003C12.866 10.0003 12.4993 9.62533 12.4993 9.16699C12.4993 8.70866 12.8743 8.33366 13.3327 8.33366C13.791 8.33366 14.166 8.70866 14.166 9.16699C14.166 9.62533 13.7993 10.0003 13.3327 10.0003Z"
        fill="#707070"
    />
</svg>
export const phoneIcon = <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M9.20768 12.4587L7.66602 14.0003C7.34102 14.3253 6.82435 14.3253 6.49102 14.0087C6.39935 13.917 6.30768 13.8337 6.21602 13.742C5.35768 12.8753 4.58268 11.967 3.89102 11.017C3.20768 10.067 2.65768 9.11699 2.25768 8.17533C1.86602 7.22533 1.66602 6.31699 1.66602 5.45033C1.66602 4.88366 1.76602 4.34199 1.96602 3.84199C2.16602 3.33366 2.48268 2.86699 2.92435 2.45033C3.45768 1.92533 4.04102 1.66699 4.65768 1.66699C4.89102 1.66699 5.12435 1.71699 5.33268 1.81699C5.54935 1.91699 5.74102 2.06699 5.89102 2.28366L7.82435 5.00866C7.97435 5.21699 8.08268 5.40866 8.15768 5.59199C8.23268 5.76699 8.27435 5.94199 8.27435 6.10033C8.27435 6.30033 8.21602 6.50033 8.09935 6.69199C7.99102 6.88366 7.83268 7.08366 7.63268 7.28366L6.99935 7.94199C6.90768 8.03366 6.86602 8.14199 6.86602 8.27533C6.86602 8.34199 6.87435 8.40033 6.89102 8.46699C6.91602 8.53366 6.94102 8.58366 6.95768 8.63366C7.10768 8.90866 7.36602 9.26699 7.73268 9.70033C8.10768 10.1337 8.50768 10.5753 8.94102 11.017C9.02435 11.1003 9.11602 11.1837 9.19935 11.267C9.53268 11.592 9.54102 12.1253 9.20768 12.4587Z"
        fill="#707070"
    />
    <path
        d="M18.3083 15.2742C18.3083 15.5076 18.2667 15.7492 18.1833 15.9826C18.1583 16.0492 18.1333 16.1159 18.1 16.1826C17.9583 16.4826 17.775 16.7659 17.5333 17.0326C17.125 17.4826 16.675 17.8076 16.1667 18.0159C16.1583 18.0159 16.15 18.0242 16.1417 18.0242C15.65 18.2242 15.1167 18.3326 14.5417 18.3326C13.6917 18.3326 12.7833 18.1326 11.825 17.7242C10.8667 17.3159 9.90832 16.7659 8.95833 16.0742C8.63333 15.8326 8.30833 15.5909 8 15.3326L10.725 12.6076C10.9583 12.7826 11.1667 12.9159 11.3417 13.0076C11.3833 13.0242 11.4333 13.0492 11.4917 13.0742C11.5583 13.0992 11.625 13.1076 11.7 13.1076C11.8417 13.1076 11.95 13.0576 12.0417 12.9659L12.675 12.3409C12.8833 12.1326 13.0833 11.9742 13.275 11.8742C13.4667 11.7576 13.6583 11.6992 13.8667 11.6992C14.025 11.6992 14.1917 11.7326 14.375 11.8076C14.5583 11.8826 14.75 11.9909 14.9583 12.1326L17.7167 14.0909C17.9333 14.2409 18.0833 14.4159 18.175 14.6242C18.2583 14.8326 18.3083 15.0409 18.3083 15.2742Z"
        fill="#707070"
    />
</svg>
export const locationIcon = <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M17.1849 7.04134C16.3099 3.19134 12.9516 1.45801 10.0016 1.45801C10.0016 1.45801 10.0016 1.45801 9.99324 1.45801C7.05154 1.45801 3.68488 3.18301 2.80988 7.03301C1.83488 11.333 4.46821 14.9747 6.85154 17.2663C7.73488 18.1163 8.86824 18.5413 10.0016 18.5413C11.1349 18.5413 12.2682 18.1163 13.1432 17.2663C15.5266 14.9747 18.1599 11.3413 17.1849 7.04134ZM10.0016 11.2163C8.55157 11.2163 7.37654 10.0413 7.37654 8.59134C7.37654 7.14134 8.55157 5.96634 10.0016 5.96634C11.4516 5.96634 12.6266 7.14134 12.6266 8.59134C12.6266 10.0413 11.4516 11.2163 10.0016 11.2163Z"
        fill="#707070"
    />
</svg>


export const homeIcon = <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    width="20"
    height="20"
>
    <path
        fill="#707070"
        d="m88.894 30.21-40-20a2.002 2.002 0 0 0-1.789 0l-40 20A2.005 2.005 0 0 0 6 32v8a2.009 2.009 0 0 0 .95 1.703 2.035 2.035 0 0 0 1.945.086L48 22.234 87.106 41.79A1.999 1.999 0 0 0 90 40v-8a2.005 2.005 0 0 0-1.106-1.79Z"
        className="color646464 svgShape"
    ></path>
    <path
        fill="#707070"
        d="M12 44.709V84a1.999 1.999 0 0 0 2 2h68a1.999 1.999 0 0 0 2-2V44.709L48 26.707Zm44.43 1.764C59.863 47.777 62 51.44 62 56.035c0 8.14-6.832 14.93-13.18 17.79a2.002 2.002 0 0 1-1.64 0C40.831 70.964 34 64.174 34 56.034c0-4.594 2.137-8.258 5.57-9.562 2.742-1.04 5.777-.344 8.43 1.867 2.652-2.211 5.688-2.906 8.43-1.867Z"
        className="color646464 svgShape"
    ></path>
    <path
        fill="#707070"
        d="M46.504 52.45A6.184 6.184 0 0 0 42.156 50a3.284 3.284 0 0 0-1.164.21C39.176 50.903 38 53.188 38 56.036c0 6.383 5.703 11.516 10 13.742 4.297-2.226 10-7.359 10-13.742 0-2.848-1.176-5.133-2.992-5.824-1.68-.633-3.68.176-5.512 2.238a2.072 2.072 0 0 1-2.992 0Z"
        className="color646464 svgShape"
    ></path>
</svg>